import React from 'react';
import TeacherBuy from './TeacherBuy';

export default class SGTeacherBuy extends TeacherBuy{
	

	 render() {
  		//var classname = this.getProductDetails()[this.props.id].ClassName;
	  	return(
	  		<section className="mtb yellow-child">
	  		<div className="container tchrbuy"> 
	        {/* <h3>Advance your career and scale your impact by joining our community!</h3> */}
			<h2>{this.rb("sg.tchrcomp.subheading")}<br/></h2>

			<ul className="galry-list">
				<li>{this.rb("sg.tchrcomp.subheading1")}</li>
				<li>{this.rb("sg.tchrcomp.subheading2")}</li>
				<li>{this.rb("sg.tchrcomp.subheading3")}</li>
			</ul>	


	  		{/* <hr className="buyoptionline"/>
	  		{this.getBuyOptions()} */}
	  		</div> 
	  		</section>
	  		);
  	}


}


// WEBPACK FOOTER //
// ./src/prelogin/src/components/SGTeacherBuy.js